<template>
  <b-modal
    v-model="show"
    title="Historial de Sueldos"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="xmd"
    scrollable
  >
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        :fields="fields"
      >
        <template #cell(amount)="data">
          <span> S/. {{ data.item.amount | currencyZero }} </span>
        </template>
        <template #cell(observation)="data">
          <span v-if="data.item.observation">
            {{ data.item.observation }}
          </span>
          <span v-else>
            <i class="text-muted">Sin observación</i>
          </span>
        </template>
        <template #cell(salary)="data">
          <span> S/. {{ data.item.salary | currencyZero }} </span>
        </template>
        <template #cell(status)="data">
          <b-badge
            :variant="
              data.item.status == '1' ? 'light-success' : 'light-danger'
            "
          >
            {{ data.item.status == "1" ? "Activo" : "Inactivo" }}
          </b-badge>
        </template>
        <template #cell(bonification)="data">
          <span> S/. {{ data.item.bonification | currencyZero }} </span>
        </template>
        <template #cell(updated_at)="data">
          <span>
            {{ data.item.updated_at | myGlobalDay }}
          </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>
  
<script>
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
// mostrar lo necesario
export default {
  data() {
    return {
      show: true,
      fields: [
        // {
        //   key: "start_date",
        //   label: "Fecha de inicio",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "end_date",
        //   label: "Fecha de fin",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "type_form",
        //   label: "Tipo Planilla",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "payment_method",
        //   label: "Método de pago",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "category",
        //   label: "Categoría",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "service_type",
        //   label: "Tipo de servicio",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "is_bono",
        //   label: "Es bono",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "ut_type",
        //   label: "Tipo UT",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "currency",
        //   label: "Moneda",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        {
          key: "amount",
          label: "Monto",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // {
        //   key: "frequency",
        //   label: "Frecuencia",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "method",
        //   label: "Método",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "bank",
        //   label: "Banco",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "account",
        //   label: "Cuenta",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "employee_id",
        //   label: "ID Empleado",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "per_provition",
        //   label: "Provisión personal",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "currency_provision",
        //   label: "Moneda de provisión",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "hours",
        //   label: "Horas",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        {
          key: "salary",
          label: "Sueldo",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "bonification",
          label: "Bonificación",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // {
        //   key: "type_provision",
        //   label: "Tipo de provisión",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "initial_provision",
        //   label: "Provisión inicial",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "current_provision",
        //   label: "Provisión actual",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "provision",
        //   label: "Provisión",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "percentage_provision",
        //   label: "Porcentaje provisión",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "type_of_agreement",
        //   label: "Tipo de acuerdo",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },

        {
          key: "status",
          label: "Estado",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "observation",
          label: "Observación",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // {
        //   key: "created_at",
        //   label: "Fecha de creación",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        {
          key: "updated_by",
          label: "Actualizado por",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "updated_at",
          label: "Actualizado el",
          tdClass: "text-center",
          thClass: "text-center",
        },
        // {
        //   key: "stever_type_id",
        //   label: "ID tipo stever",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
        // {
        //   key: "apply_attendance",
        //   label: "Aplica asistencia",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
      ],
      items: [],
    };
  },
  async mounted() {
    await this.getEmployeeVacations();
  },
  methods: {
    async getEmployeeVacations() {
      try {
        this.addPreloader();
        const params = {
          employee_id: this.$route.params.id,
        };
        const { data } = await EmployeeService.getHistorialSueldos(params);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
  
  <style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>